import {
  doc,
  deleteDoc
} from "firebase/firestore";

import { db } from "../firebase";
import Cookies from "js-cookie";
import { deleteFileByUid } from "../components_root/deleteFileByUid";

export const Delete_page = async (data) => {
  const {
    pageuid,
    fileuid,
    contentuid,
    companyuid
  } = data || {};

  // ================= VALIDATION =================
  if (!pageuid?.trim()) {
    return { success: false, error: "Missing pageuid" };
  }

  if (!companyuid?.trim()) {
    return { success: false, error: "Missing companyuid" };
  }

  if (!contentuid?.trim()) {
    return { success: false, error: "Missing contentuid" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || !guid) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  try {
    // ================= DELETE FIRESTORE DOC =================
    const docRef = doc(
      db,
      "companies",
      companyuid,
      "pages",
      pageuid,
      "contentdata",
      contentuid // ✅ correct path
    );

    await deleteDoc(docRef);

    // ================= DELETE FILE (SAFE) =================
    if (
      fileuid &&
      typeof fileuid === "string" &&
      fileuid.trim() !== ""
    ) {
      try {
        console.log("DELETE START", { contentuid, fileuid, companyuid });
        await deleteFileByUid({ pageuid, fileuid, contentuid, companyuid }); 
        console.log("✅ File deleted:", companyuid);
      } catch (fileErr) {
        console.warn("⚠️ File delete failed:", fileErr.message);
      }
    } else {
      console.log("ℹ️ No valid fileuid, skipping file delete");
    }

    return { success: true };

  } catch (err) {
    console.error("❌ Delete_page error:", err);

    return {
      success: false,
      error: err.message || "Delete failed"
    };
  }
};